import { useCallback } from 'react';
import { Player } from '@remotion/player';
import { SaasOnboardingDemo } from '../components/demo/saas-onboarding-demo';

export function DemoSaasRoute() {
  const renderLoading = useCallback(() => {
    return (
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: '#f8fafc',
          backgroundImage:
            'linear-gradient(#e2e8f0 1px, transparent 1px), linear-gradient(90deg, #e2e8f0 1px, transparent 1px)',
          backgroundSize: '48px 48px',
          opacity: 0.4,
        }}
      />
    );
  }, []);

  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        backgroundColor: '#f8fafc',
        overflow: 'hidden',
      }}
    >
      <Player
        component={SaasOnboardingDemo}
        durationInFrames={300}
        fps={30}
        compositionWidth={1920}
        compositionHeight={1080}
        style={{ width: '100%', height: '100%' }}
        autoPlay
        loop
        renderLoading={renderLoading}
      />
    </div>
  );
}
